export default __webpack_public_path__ + "81231cf7404e0741b6c438e23d091f52.svg";